var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuestSpeakers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F2F4F7",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    fillRule: "evenodd",
    d: "M17.75 14.75a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75Zm-3.375 1.875a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0ZM28.03 13.47a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06 0l-1.5-1.5a.75.75 0 1 1 1.06-1.06l.97.97 2.47-2.47a.75.75 0 0 1 1.06 0ZM16.07 21.5h3.362c.604 0 1.102 0 1.508.033.421.035.809.108 1.173.294a3 3 0 0 1 1.311 1.311c.186.364.26.752.294 1.173.033.406.033.904.033 1.508v.931a.75.75 0 0 1-1.5 0v-.9c0-.642 0-1.08-.028-1.417-.027-.328-.076-.497-.136-.614a1.5 1.5 0 0 0-.655-.655c-.117-.06-.286-.109-.614-.136-.338-.027-.775-.028-1.417-.028h-3.3c-.642 0-1.08 0-1.417.028-.329.027-.497.076-.614.136a1.5 1.5 0 0 0-.655.655c-.06.117-.109.286-.136.614-.027.338-.028.775-.028 1.417v.9a.75.75 0 0 1-1.5 0v-.931c0-.604 0-1.102.033-1.508.035-.421.109-.809.294-1.173a3 3 0 0 1 1.311-1.311c.364-.186.752-.26 1.173-.294.406-.033.904-.033 1.508-.033Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestSpeakers);
export default __webpack_public_path__ + "static/media/guest-speakers.55fd385c3ff82ea57e28a3c6c34d1306.svg";
export { ForwardRef as ReactComponent };